import React from 'react';

import { Card } from 'primereact/card';

import { Divider } from 'primereact/divider';
 
const FitnessCertificate = () => {

  return (
<div className="p-6 max-w-3xl mx-auto bg-white border rounded-xl shadow-md">
<div className="flex justify-between items-center mb-4">
<span className="text-sm font-medium">2025-26</span>
<div className="flex items-center space-x-2">
<div className="w-10 h-10 bg-gray-300 rounded-full" />
<div className="w-10 h-10 bg-gray-300 rounded-full" />
</div>
</div>
 
      <div className="text-center">
<h2 className="text-xl font-bold uppercase">Islamabad Transport Authority</h2>
<p className="text-sm mt-1">See Section 3(1) & 40 (2)</p>
<h3 className="text-lg font-semibold mt-1 underline">Certificate of Fitness</h3>
<p className="text-sm mb-4">Applicable in the Case of Transport Vehicles</p>
</div>
 
      <Divider />
 
      <div className="text-sm space-y-2">
<div className="grid grid-cols-2 gap-4">
<div>CFX No. 1198</div>
<div className="text-right">MVE District Islamabad</div>
</div>
 
        <div className="grid grid-cols-2 gap-4">
<div>Vehicle No. <strong>LOK-938</strong></div>
<div className="text-right">Model <strong>1992</strong></div>
</div>
 
        <div className="grid grid-cols-2 gap-4">
<div>Chassis No. <strong>2672</strong></div>
<div className="text-right">Engine No. <strong>6898</strong></div>
</div>
 
        <div className="mt-4">
<p>

            Make - Pickup 2ID - is certified as complying with the Provision of Chapter VI of the West Pakistan Motor Vehicle Ordinance, 1965 and the Rules Made there Under.
</p>
</div>
 
        <div className="mt-4 font-medium">

          The Certificate will expire on next Inspection Date: <strong>13-04-2026</strong>
</div>
 
        <div className="mt-2 text-sm">Date: <strong>13-04-2026</strong></div>
</div>
</div>

  );

};
 
export default FitnessCertificate;

 